import * as tslib_1 from "tslib";
import { Api } from '../api/api';
import * as i0 from "@angular/core";
import * as i1 from "../api/api";
var IrowService = /** @class */ (function () {
    function IrowService(api) {
        this.api = api;
    }
    IrowService.prototype.getPlans = function (county, route, segment) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.api.http2.get("irow/plans/" + county + "/" + route + "/" + segment)];
            });
        });
    };
    IrowService.ngInjectableDef = i0.defineInjectable({ factory: function IrowService_Factory() { return new IrowService(i0.inject(i1.Api)); }, token: IrowService, providedIn: "root" });
    return IrowService;
}());
export { IrowService };
